
import { logError } from '../components/lms-shared/errors/error'
import { throwApiError } from '../components/lms-shared/store/error-handling-actions'
import { usersApi } from '../utils'
import { authActions } from './auth-slice'

export const checkLogin = (applictionName) => {
    return async (dispatch, getState) => {
        try {
            let res = await fetch(`${window.config.identityURL}/auth/my`, {
                credentials: "include"
            })
            let data = await res.json();
            if (!data.isAuth) {
                login(applictionName);
            } else {
                if(localStorage.getItem("trytofixbegin")){
                    localStorage.removeItem("trytofixbegin");
                    logError("try to fix login successes","try to fix login successes","LOGIN")
                }
                dispatch(authActions.setInitial(data))
                // call filter instead of isExist
                // usersApi.usersIsExistGet((error, resdata, response) => {
                //     if (error) {
                //         // alert("getUserIsExist", error)
                //         console.log(error)
                //     } else {
                //         dispatch(authActions.login(response.body))
                //     }
                // })
                const state = getState();

                const filterData = {
                    // applicationId is not important in student side
                    applicationId: null
                }
                usersApi.usersFilterPost({ userFilterInput: filterData }, (error, resdata, response) => {
                    if (error) {
                        dispatch(throwApiError({ userMessage: state.translate.loginError ? state.translate.loginError : "לא הצלחנו לזהות אותך, מנסים שוב...", error: error, statusCode: response?.statusCode, message: "usersFilterPost " + error.message, level: 3, component: "auth-actions", line: 34 }))
                    } else {
                        dispatch(authActions.login(response.body))
                    }
                })
            }
        } catch {

        }
    }
}

export const initLmsUser = () => {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const filterData = {
                applicationId: state.application.applicationId
            }
            usersApi.usersFilterPost({ userFilterInput: filterData }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: "לא הצלחנו לזהות אותך", error: error, statusCode: response?.statusCode, message: " " + error.message, level: 2, component: "auth-actions", line: 56 }))
                } else {
                    dispatch(authActions.login(response.body))
                }
            })
        } catch {

        }
    }
}

export const fatchLogout = (path) => {
    window.location.href = `${window.config.identityURL}/auth/logout?next=${window.location.origin}/student${path}`
}

export const login = (path) => {
    window.location.href = `${window.config.identityURL}/auth/eduidp?next=${window.location.href}&nextError=${window.location.origin}/${path}/error`

}
